import { render } from "./riplayUmum.vue?vue&type=template&id=04091556"
import script from "./riplayUmum.vue?vue&type=script&lang=js"
export * from "./riplayUmum.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__